import { defineMessages } from "@/i18n";
import en from "./en";

export const desktopBrowserMessages = defineMessages("desktop-browser", en);
